// Formatting modifiers belong to the presentation of a counter, never its id.
// Keep them attached when an outline resolves a template id to a list instance.
export function resolveListFormat(format, currentLevels, levelCounters) {
  return format.replace(/({.*?})/g, token => {
    const [source, ...modifiers] = token.slice(1, -1).split('|');
    let counter = source;
    const decimal = counter.startsWith('D');
    const padded = counter.startsWith('2:');
    const prefix = `${decimal ? 'D' : ''}${padded ? '2:' : ''}`;
    counter = decimal ? counter.substr(1) : counter;
    counter = padded ? counter.substr(2) : counter;
    const resolved = currentLevels[counter];
    levelCounters.push(resolved);
    const suffix = modifiers.length ? `|${modifiers.join('|')}` : '';
    return `{${prefix}${resolved}${suffix}}`;
  });
}

export function formatWordListToken(token, counters, toWords) {
  const match = token.match(/^\{([^{}|]+)\|words(?:\|(title))?\}$/);
  if (!match) return null;

  const counter = match[1];
  if (counters[counter] === undefined) counters[counter] = 1;
  // Reuse the editor's English cardinal spelling; hyphenate compound tens.
  let words = toWords(counters[counter])
    .trim()
    .replace(
      /\b(twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety) (one|two|three|four|five|six|seven|eight|nine)\b/g,
      '$1-$2',
    );
  if (match[2] === 'title')
    words = words.replace(/\b[a-z]/g, letter => letter.toUpperCase());
  return words;
}

function normalizeLegacyFormat(format) {
  return format
    .replace(/([A-Z]+)(}|\])+/g, 'A}')
    .replace(/([0-9]+)(}|\])+/g, '0}')
    .replace(/([a-z]+)(}|\])+/g, 'a}');
}

export function normalizeListFormat(format) {
  if (!format.includes('|words')) return normalizeLegacyFormat(format);

  return format.replace(/({.*?})/g, token => {
    const [counter, ...modifiers] = token.slice(1, -1).split('|');
    const normalized = normalizeLegacyFormat(`{${counter}}`);
    return modifiers.length
      ? `${normalized.slice(0, -1)}|${modifiers.join('|')}}`
      : normalized;
  });
}
